import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="py-20 md:py-28 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 mb-12 md:mb-16">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-green mb-4">
          Lo que dicen de nosotras
        </p>
        <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.9]">
          Clientes felices,<br />comunidades vivas.
        </h2>
      </div>

      <Marquee speed={40} gradient={false} pauseOnHover className="marquee-mask">
        {TESTIMONIALS.concat(TESTIMONIALS).map((t, i) => (
          <div
            key={i}
            data-testid={`testimonial-${i}`}
            className="w-[340px] md:w-[440px] mx-3 p-8 md:p-10 rounded-3xl bg-white border border-ink/10 flex flex-col justify-between min-h-[240px]"
          >
            <Quote className="text-mango mb-5" size={34} />
            <p className="font-display text-lg md:text-xl leading-snug tracking-tight text-ink mb-6">
              “{t.quote}”
            </p>
            <div className="flex items-center gap-3">
              <span className="h-10 w-10 rounded-full bg-green/15 grid place-items-center font-bold text-green">
                {t.author.charAt(0)}
              </span>
              <div>
                <p className="font-semibold text-sm">{t.author}</p>
                <p className="text-ink/50 text-xs">{t.company}</p>
              </div>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
